<template>
  <auth-layout :heading="$t('heading')">
    <v-alert
      v-if="registrationComplete"
      :value="true"
      type="success">{{ $t('registrationComplete') }}
    </v-alert>
    <template v-else>
      <v-form v-model="isValidForm">
        <h3 class="title">{{ $t('loginData') }}</h3>

        <email-input
          v-model="newUser.email"
          :error-messages="errorMessages.email"
        />

        <password-pair
          :password="newUser.password"
          :password_confirmation="newUser.password_confirmation"
          :error-messages="errorMessages.password"
          @changed="val => newUser.password = val"
          @changedConfirm="val => newUser.password_confirmation = val"
          @submit="register"
        />

        <h3 class="title mt-4 mb2">{{ $t('personal') }}</h3>

        <v-layout
          row
          wrap>
          <v-flex xs12>
            <v-text-field
              v-model="newUser.first_name"
              :error-messages="errorMessages.first_name"
              :label="$t('firstName')"
              :rules="[$rules.isRequired]"/>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="newUser.last_name"
              :error-messages="errorMessages.last_name"
              :label="$t('lastName')"
              :rules="[$rules.isRequired]"/>
          </v-flex>
        </v-layout>
      </v-form>
      <v-btn
        slot="action"
        :loading="isLoading"
        :disabled="!isValidForm || isLoading"
        color="primary"
        @click="register">{{ $t('send') }}
      </v-btn>
    </template>
    <v-btn
      slot="navigation"
      :to="{name: 'login'}"
      flat
    >
      {{ $t('back') }}
    </v-btn>
  </auth-layout>
</template>

<script>
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'
import PasswordPair from '@/components/global-components/inputs/PasswordPair.vue'
import AuthLayout from '@/components/layouts/AuthLayout'
import userApi from '@/api/UserApi'

export default {
  name: 'Registration',
  components: {
    AuthLayout,
    EmailInput,
    PasswordPair
  },
  data () {
    return {
      isValidForm: false,
      isLoading: false,
      newUser: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      registrationComplete: false,
      errorMessages: {}
    }
  },
  methods: {
    async register () {
      if (!this.isValidForm) return

      this.newUser.password_confirmation = this.newUser.password

      this.isLoading = true
      try {
        const result = await userApi.registration(this.newUser)
        if (result.success) {
          this.registrationComplete = true
        }
      } catch (e) {
        this.errorMessages = e.errors
      }
      this.isLoading = false
    }
  },
  watch: {
    newUser: {
      deep: true,
      handler () { this.errorMessages = {} }
    }
  },
  mounted () {
    const aff = localStorage.getItem('aff')
    if (aff) {
      this.newUser.aff = aff
    }
  },
  i18n: {
    messages: {
      de: {
        firstName: 'Vorname',
        heading: 'Registrierung',
        lastName: 'Nachname',
        loginData: 'Anmeldedaten',
        personal: 'Persönliche Daten',
        send: 'Registrieren',
        registrationComplete: 'Ihre Registrierung war erfolgreich. Wir haben Ihnen eine Email geschickt.',
        back: 'Zurück'
      },
      en: {
        firstName: 'First name',
        heading: 'Sign up',
        lastName: 'Last name',
        loginData: 'Login data',
        personal: 'Personal data',
        send: 'Send',
        registrationComplete: 'Your registration was successful. We sent you an email.',
        back: 'Back'
      },
      tr: {
        firstName: 'İsim',
        heading: 'Hesap oluşturun',
        lastName: 'Soyisim',
        loginData: 'Giriş bilgileri',
        personal: 'Kişisel bilgiler',
        send: 'Gönder',
        registrationComplete: 'Kaydınız başarılı bir şekilde oluşturuldu. Size bir e-posta gönderdik.',
        back: 'Geri'
      },
      ru: {
        firstName: 'Имя',
        heading: 'Регистрация',
        lastName: 'Фамилия',
        loginData: 'Данные для входа',
        personal: 'Персональыне данные',
        send: 'Отправить',
        back: 'Назад'
      }
    }
  }
}
</script>
